import React, { SVGProps } from "react";

export default function SupTilda(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.85621 11.2952L3.98108 9.51223C5.29999 8.40553 7.17911 8.26696 8.64609 9.16822L11.3541 10.8319C12.8211 11.7332 14.7002 11.5946 16.0191 10.4879L18.1439 8.70492"
        stroke="currentColor"
      />
    </svg>
  );
}
